<template>
  <div>
     <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <!-- Form -->
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>          
          <v-container grid-list-md>
            <v-layout wrap>     

              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  label="Financial Year"                  
                  v-model="formSchema.years"
                  :items="BudgetingYearList"
                  :rules="[v => !!v || 'Financial year is required !']"
                  required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>                
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:1,fieldName:'start_date', fieldValue:formSchema.start_date, label:'Start Date',required:'1'}"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <DatePicker
                  :key="formSchema.id"
                  :inputData="{index:2,fieldName:'end_date', fieldValue:formSchema.end_date, label:'End Date',required:'1', disabled:'1'}"
                  ref="setRange"
                  @setValue="setDateValue"
                ></DatePicker>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Related Document"
                  v-model="formSchema.document_name"                  
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                File
                <input
                  type="file"
                  id="files2"
                  ref="image2"
                  v-on:change="handleFilesUpload()"
                />
              </v-flex>

              <v-flex xs12 sm6 md4 >
                <v-checkbox v-model="formSchema.is_active" label="Active" :value="is_activeVal"></v-checkbox>
              </v-flex>
              <div style="overflow: auto; white-space: nowrap;">
              <table class="reportTbl" width="100%">
                <tbody>
                  <tr class="textCenter textBold">
                    <th rowspan="2">Category</th>
                    <th colspan="2">Q1</th>
                    <th colspan="2">Q2</th>
                    <th colspan="2">Q3</th>
                    <th colspan="2">Q4</th>
                  </tr>
                  <tr class="textCenter textBold">
                    <th>Credit A</th>
                    <th>Credit B</th>
                    <th>Credit A</th>
                    <th>Credit B</th>
                    <th>Credit A</th>
                    <th>Credit B</th>
                    <th>Credit A</th>
                    <th>Credit B</th>
                  </tr>
                  <tr>
                    <td>                      
                      <v-autocomplete                
                      v-model="formSchema.quater[0].category"
                      :items="['ADP','NonADP']"
                      ></v-autocomplete>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q1_creditA" :rules="[decimalShort]" @input="SumValues('q1_creditA','Q1_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q1_creditB" :rules="[decimalShort]" @input="SumValues('q1_creditB','Q1_total_B')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q2_creditA" :rules="[decimalShort]" @input="SumValues('q2_creditA','Q2_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q2_creditB" :rules="[decimalShort]" @input="SumValues('q2_creditB','Q2_total_B')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q3_creditA" :rules="[decimalShort]" @input="SumValues('q3_creditA','Q3_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q3_creditB" :rules="[decimalShort]" @input="SumValues('q3_creditB','Q3_total_B')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q4_creditA" :rules="[decimalShort]" @input="SumValues('q4_creditA','Q4_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[0].q4_creditB" :rules="[decimalShort]" @input="SumValues('q4_creditB','Q4_total_B')"></v-text-field>
                    </td>
                  </tr>

                  <tr>
                    <td>                      
                      <v-autocomplete                
                      v-model="formSchema.quater[1].category"
                      :items="['ADP','NON-ADP']"
                      ></v-autocomplete>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q1_creditA"
                      :rules="[decimalShort]" @input="SumValues('q1_creditA','Q1_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q1_creditB" :rules="[decimalShort]" @input="SumValues('q1_creditB','Q1_total_B')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q2_creditA" :rules="[decimalShort]" @input="SumValues('q2_creditA','Q2_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q2_creditB" :rules="[decimalShort]" @input="SumValues('q2_creditB','Q2_total_B')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q3_creditA" :rules="[decimalShort]" @input="SumValues('q3_creditA','Q3_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q3_creditB" :rules="[decimalShort]" @input="SumValues('q3_creditB','Q3_total_B')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q4_creditA" :rules="[decimalShort]" @input="SumValues('q4_creditA','Q4_total_A')"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="formSchema.quater[1].q4_creditB" :rules="[decimalShort]" @input="SumValues('q4_creditB','Q4_total_B')"></v-text-field>
                    </td>
                  </tr>

                  <tr class="textCenter textBold">
                    <td>Total</td>
                    <td><v-text-field v-model="formSchema.Q1_total_A" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q1_total_B" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q2_total_A" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q2_total_B" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q3_total_A" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q3_total_B" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q4_total_A" readonly hide-details></v-text-field></td>
                    <td><v-text-field v-model="formSchema.Q4_total_B" readonly hide-details></v-text-field></td>
                  </tr>
                </tbody>
              </table>
            </div>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="$refs.form.reset" @click="resetForm">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <!-- /Form -->

  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
let utilities = require("../../../utilities/utilities");
import DatePicker from "../../global/date_picker";

export default {
  props: ["formSchema"],
  components: {
    DatePicker
  },
  data: () => ({
    valid: true,
    is_activeVal:1,
    documentFiles: [],
    BudgetingYearList: utilities.getBudgetingYearList(),

    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit Project Cash Statement" : "Add Project Cash Statement";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
    
    // Table data load reques Methods
    // commonService.getAllData("asset_category").then(res => {
    //   this.showForm = this.userRole.saveButton;
    //   this.items = res.data;
    //   this.loading = false;
    // });
    
  },

  created() {
    // commonService.getAllData("operation-activities").then(res => {
    //   if (res.status == "success") {
    //     this.projectList = res.data;
    //   }
    // });    
  },

  methods: {
    setDateValue(data) {
      let index = data.index
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "start_date"){
        this.formSchema.end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },

    SumValues(fieldName,totalFiel)
    {
      let A = this.formSchema.quater[0][fieldName];
      let B = this.formSchema.quater[1][fieldName];
      let Total = this.formSchema[totalFiel] = ((parseFloat(A) || 0) + (parseFloat(B)||0)).toFixed(3);
    },

    validateBeforeSubmit(e) {
      
      let formData = new FormData();
      var formSchema = this.formSchema;

      // if ((this.documentFiles.length == 0 ) && (this.formSchema.upload_file_name == "")) {
      //   this.close({ message: "You don't select any file!", status: 0 });
      //   return false;
      // }

      if (this.$refs.form.validate()) {

        formSchema.start_date = this.changeFormateYMD(
          formSchema.start_date
        );

        formSchema.end_date = this.changeFormateYMD(
          formSchema.end_date
        );

        let formData = new FormData();

        for (var i = 0; i < this.documentFiles.length; i++) {
          let file = this.documentFiles[i];
          formData.append("files[" + i + "]", file);
        }

        formSchema.record_id = sessionStorage.getItem("mm_id");
        formSchema.sub_menu_id = sessionStorage.getItem("sm_id");

        formData.append("fieldValues", JSON.stringify(formSchema));

        commonService.insertFormData(formData, "project-forcust-report").then(res => {
          let actionData = {
            message: res.message,
            data: res.data,
            action: res.action,
            status: res.status
          };

          if (res.status == 1) {
            this.$refs.form.reset();
            this.formSchema.id = 0;
            this.formSchema.start_date = ''
            this.formSchema.end_date = ''
          }
          this.close(actionData);
        });
      }
    },

    handleFilesUpload() {
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("uploadedFiles", uploadedFiles);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.doc|\.docx|\.doc)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {
        
        this.SnackbarVal.message = "You can upload jpg, jpeg, png, pdf, doc and docx file only";
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = 'error';

        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.documentFiles.push(uploadedFiles[i]);
        }
      }
    },
    
    resetForm(){
      this.formSchema.id = 0;      
    },

    close: function(data) {      
      this.documentFiles = [];
      document.getElementById("files2").value = null;
      this.$emit("emitForm", data);
    }
  }
};
</script>
<style scoped>
table.reportTbl{
  border-collapse: collapse;
}
.reportTbl th{
  line-height: 30px;
}
.reportTbl th,
.reportTbl tr td{
  border:1px solid #CCC !important;  
}
.reportTbl tr.textCenter,
.textCenter
{
  text-align: center;
}
.reportTbl tr.textBold,
.textBold{
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/project_info/project_forcust_report/insertForm.vue